import { IBitwisePayload } from 'components/foundation/BitwiseGroup/BitwiseGroup';
import { t } from 'utils/localize';
import { EquipmentSelectionOptions } from '__generated__/graphql';

export const defaultBitwisePayloads: IBitwisePayload[] = [
  {
    enabled: true,
    name: t('Self'),
    value: 1,
  },
  {
    enabled: true,
    name: t('Lower Positions'),
    value: 2,
  },
  {
    enabled: true,
    name: t('Same Position'),
    value: 4,
  },
  {
    enabled: true,
    name: t('Higher Positions'),
    value: 8,
  },
];

export const equipmentRequireKeyStringLookup: Record<EquipmentSelectionOptions, string> = {
  [EquipmentSelectionOptions.Off]: t('Off'),
  [EquipmentSelectionOptions.Recommended]: t('Opt-Out Required'),
  [EquipmentSelectionOptions.Required]: t('Required'),
};
